/* global serviceModule */
import {Injectable} from "@angular/core";
// TBD: make an object api for the scoring data

@Injectable()
export class MicrophoneCheckDataService {

    private MIC_CHECK_SENTENCE:Object = {
        "dictionary": {
            "ONE": [
                "W AH N"
            ],
            "TWO": [
                "T UW"
            ],
            "THREE": [
                "TH R IY"
            ],
            "FOUR": [
                "F AO R"
            ],
            "FIVE": [
                "F AY V"
            ],
            "SIX": [
                "S IH K S"
            ],
            "SEVEN": [
                "S EH V AH N"
            ],
            "EIGHT": [
                "EY T"
            ],
            "NINE": [
                "N AY N"
            ],
            "TEN": [
                "T EH N"
            ]
        },
        "grammar": {
            "numbers": {
                "words": [
                    "ONE",
                    "TWO",
                    "THREE",
                    "FOUR",
                    "FIVE",
                    "SIX",
                    "SEVEN",
                    "EIGHT",
                    "NINE",
                    "TEN"
                ],
                "sentence": "1 2 3 4 5 6 7 8 9 10"
            }
        }
    };


    private OLD_MIC_CHECK_SENTENCE:Object = {
        dictionary: [{"w": "ONE", "p": "W AH N"}, {"w": "TWO", "p": "T UW"}, {"w": "THREE", "p": "TH R IY"}, {
            "w": "FOUR",
            "p": "F AO R"
        }, {"w": "FIVE", "p": "F AY V"},
            {"w": "SIX", "p": "S IH K S"}, {"w": "SEVEN", "p": "S EH V AH N"}, {"w": "EIGHT", "p": "EY T"}, {
                "w": "NINE",
                "p": "N AY N"
            }, {"w": "TEN", "p": "T EH N"}],
        grammar: {
            numbers: {
                sentence: "1 2 3 4 5 6 7 8 9 10",
                word: ["ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE", "TEN"],
                grammar: {
                    start: 0,
                    end: 10,
                    numStates: 11,
                    transitions: [{"from": 0, "to": 1, "word": "ONE"}, {"from": 1, "to": 2, "word": "TWO"}, {
                        "from": 2,
                        "to": 3,
                        "word": "THREE"
                    },
                        {"from": 3, "to": 4, "word": "FOUR"}, {"from": 4, "to": 5, "word": "FIVE"}, {
                            "from": 5,
                            "to": 6,
                            "word": "SIX"
                        },
                        {"from": 6, "to": 7, "word": "SEVEN"}, {"from": 7, "to": 8, "word": "EIGHT"}, {
                            "from": 8,
                            "to": 9,
                            "word": "NINE"
                        },
                        {"from": 9, "to": 10, "word": "TEN"}]
                }
            }
        }
    };

    public getMicDictionary() {
        return this.MIC_CHECK_SENTENCE["dictionary"];
    }

    public getGrammarCountToTen() {
        return this.MIC_CHECK_SENTENCE["grammar"]["numbers"];
    }

    public getGrammarSentences() {
        return this.MIC_CHECK_SENTENCE["grammar"]["sentences"];
    }

}
